module.exports = __webpack_public_path__ + "img/josh-morgan.48d4ad58.png";